__turbopack_context__.v({
  "part": "ArticleModuleHeroSidebarSectionCopyright-module-scss-module__ehXk6G__part",
});
